const RemoveSpacing = () => {
  return <div className="-mb-28 md:-mb-32 lg:-mb-36"></div>;
};

export default RemoveSpacing;
